import moment from "moment";
import { isMobile } from "react-device-detect";

const initialState = {
  token: localStorage.getItem("token_auth"),
  isAuthenticated: null,
  isLoading: true,
  user: null,
  isLoadingMessages: true,
  isLoadingMessages2: false,
  isSocketLoading: true,
  loginFailed: false,
  notifications: [],
  unseenNotifications: [],
  isLoadingNotifications: true,
  entryPage: null,
  alert: null,
  expiry: null,
  tier: null,
  initiated: "PENDING",
  finalized: false,
  classType: "STANDARDS",
  currentYear: "2025-2026",
  studentCategories: ["GENERAL"],
  institutionName: "",
  language: "en",
  student: null,
  isLoadingStudent: true,
  isMobile: isMobile,
  class_id: "",
  division: "",
  selectedContact: null,
  selectedContactIndex: null,
  currentContacts: [],
  searchText: "",
};

export default function (state = initialState, action) {
  console.log("-------------");
  console.log(action.type);
  // console.log(action.payload);
  console.log("-------------");

  switch (action.type) {
    case "USER_LOADING":
      return {
        ...state,
        token: localStorage.getItem("token_auth"),
      };
    case "SELECT_CONTACT":
      return {
        ...state,
        selectedContactIndex: action.payload.selectedContactIndex,
        selectedContact: action.payload.selectedContact,
        selectedContactName: action.payload.selectedContactName,
      };
    case "CURRENT_CONTACTS":
      return {
        ...state,
        currentContacts: action.payload,
      };
    case "SEARCH_TEXT":
      return {
        ...state,
        searchText: action.payload,
      };
    case "CURRENT_CLASS_DIVISION":
      return {
        ...state,
        class_id: action.payload.class_id,
        division: action.payload.division,
      };
    case "USER_LOADED":
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload,
      };
    case "LOADING_MESSAGES2":
      return {
        ...state,
        isLoadingMessages2: true,
      };
    case "CONTACTS_LOADED":
      return {
        ...state,
        contacts: action.payload,
      };
    case "CURRENT_CONTACTS":
      return {
        ...state,
        currentContacts: action.payload,
      };
    case "MESSAGES_LOADED":
      return {
        ...state,
        messages: action.payload,
        isLoadingMessages: false,
        isLoadingMessages2: false,
      };
    case "SOCKET_LOADED":
      return {
        ...state,
        client: action.payload,
        isSocketLoading: false,
      };
    case "TEXT_MESSAGE":
      return {
        ...state,
        message: action.payload,
      };
    case "STUDENT_LOADING":
      return {
        ...state,
        isLoadingStudent: true,
      };
    case "MOBILE_VIEW":
      return {
        ...state,
        isMobile: action.payload,
      };
    case "STUDENT_LOADED":
      return {
        ...state,
        isLoggingIn: false,
        student: action.payload,
        isLoadingStudent: false,
      };
    case "INIT_APP_INFO":
      return {
        ...state,
        currentYear: action.payload["current_year"],
        initiated:
          action.payload["setup_status"] == null
            ? "PENDING"
            : action.payload["setup_status"]["initiated"],
        finalized:
          action.payload["setup_status"] == null
            ? false
            : action.payload["setup_status"]["finalized"],

        contacts: action.payload["contacts"] ?? [],
        isLoading: false,
        expiry:
          action.payload["subscription"] == null
            ? null
            : moment(
                action.payload["subscription"]["expiry"],
                "DD-MM-YYYY",
              ).toDate(),
        tier:
          action.payload["subscription"] == null
            ? null
            : action.payload["subscription"]["tier"],
        messages: action.payload["messages"] ?? [],
        isLoadingMessages: false,
        isAuthenticated: true,
        user: action.payload["user"],
        isSocketLoading: false,
        token: action.payload["token"],
      };
    case "INIT_APP_INFO_2":
      return {
        ...state,
        current_year: action.payload["current_year"],
        initiated: action.payload["setup_status"]["initiated"],
        finalized: action.payload["setup_status"]["finalized"],
        expiry:
          action.payload["subscription"] == null
            ? null
            : moment(
                action.payload["subscription"]["expiry"],
                "DD-MM-YYYY",
              ).toDate(),
        tier:
          action.payload["subscription"] == null
            ? null
            : action.payload["subscription"]["tier"],
        isLoadingStudent: false,
        isLoggingIn: false,
        student: action.payload["student"],
      };
    case "SUBSCRIPTION":
      return {
        ...state,
        isLoading: false,
        expiry: moment(action.payload.expiry, "DD-MM-YYYY").toDate(),
        tier: action.payload.tier,
      };
    case "CLEAR_STUDENT":
      return {
        ...state,
        isLoadingStudent: true,
      };
    case "LOGIN_SUCCESS":
      localStorage.setItem("token_auth", "Token " + action.payload.token);
      return {
        ...state,
        token: "Token " + action.payload.token,
        loginFailed: false,
      };
    case "LOGOUT_SUCCESS":
      localStorage.removeItem("token_auth");
      return {
        ...state,
        token: null,
        user: null,
        isAuthenticated: false,
        isLoadingMessages: true,
        isSocketLoading: true,
        isLoading: true,
        messages: null,
        message: null,
        loginFailed: true,
      };
    case "PASSWORD_RESET":
      localStorage.removeItem("token_auth");
      return {
        ...state,
        token: null,
        user: null,
        isAuthenticated: false,
        isLoadingMessages: true,
        isSocketLoading: true,
        isLoading: true,
        messages: null,
        message: null,
        loginFailed: true,
      };

    case "AUTH_ERROR":
      localStorage.removeItem("token_auth");
      return {
        ...state,
        token: null,
        user: null,
        isAuthenticated: false,
        isLoadingMessages: true,
        isSocketLoading: true,
        isLoading: true,
        messages: null,
        message: null,
        loginFailed: true,
      };
    case "RESET_REDIRECT_LOGIN":
      return {
        ...state,
        loginFailed: false,
      };
    case "ALERT":
      return {
        ...state,
        alert: {
          title: action.payload.title,
          message: action.payload.message,
          type: action.payload.type,
        },
      };
    case "REMOVE_ALERT":
      return {
        ...state,
        alert: null,
      };
    case "CURRENT_YEAR":
      return {
        ...state,
        current_year: action.payload,
      };
    case "SETUP_STATUS":
      return {
        ...state,
        initiated: action.payload["initiated"],
        finalized: action.payload["finalized"],
        classType: action.payload["class_type"],
        currentYear: action.payload["current_year"],
        institutionName: action.payload["institution_name"],
        studentCategories: action.payload["student_categories"],
      };
    case "NOTIFICATIONS_LOADED":
      return {
        ...state,
        notifications: action.payload,
        isLoadingNotifications: false,
      };
    case "UNSEEN_NOTIFICATIONS_LOADED":
      return {
        ...state,
        unseenNotifications: action.payload,
      };
    case "ENTRY_PAGE":
      return {
        ...state,
        entryPage: action.payload,
      };
    case "REFRESH_DATA":
      return {
        ...state,
        refresh: action.payload,
      };
    default:
      return state;
  }
}
